import React from 'react'
import { routesDef } from '../config/routes'
import { useHistory } from '@ztechapps/common.hook'

export const SeeOurProductsButton = () => {
  const history = useHistory()

  return (
    <button
      type="button"
      className="mt-5 mb-5 btn btn-lg btn-primary"
      onClick={(e) => {
        e.preventDefault()
        history.push(routesDef.ProductListPage.altPath())
      }}
    >
      See our products...
    </button>
  )
}
